import React from "react";
import twoD from "../../assets/img/2d design view.png";
const TwoDView = () => {
  return (
    <div
      className="max-h-[calc(100vh-8rem)] h-full mx-auto"
      style={{ aspectRatio: 1.29 }}
    >
      <img src={twoD} alt="" className="w-full h-full object-contain" />
    </div>
  );
};

export default TwoDView;
